const sendAnalyticsEvent = function (
  event,
  eventCategory,
  eventAction,
  eventLabel
) {
  console.log(
    '-------------> Analytics',
    event,
    eventCategory,
    eventAction,
    eventLabel
  );
  try {
    dataLayer.push({
      event: event,
      component: eventCategory,
      detail: eventAction,
      label: eventLabel,
    });
  } catch (error) {
    console.log('Analytics error');
  }
};

const turnAnalyticsListenersOn = function () {
  let analyticsItems = document.querySelectorAll(
    '[data-eventcategory]:not(.btn-ajax)'
  );
  Array.prototype.forEach.call(analyticsItems, function (item, index) {
    switch (item.tagName.toLowerCase()) {
      case 'input':
        item.addEventListener('blur', function (e) {
          if (item.value !== '') {
            sendAnalyticsEvent(
              'event_data',
              item.dataset.eventcategory,
              item.dataset.eventaction,
              item.dataset.eventlabel
            );
          }
        });
        break;
      case 'textarea':
        item.addEventListener('blur', function (e) {
          if (item.value !== '') {
            sendAnalyticsEvent(
              'event_data',
              item.dataset.eventcategory,
              item.dataset.eventaction,
              item.dataset.eventlabel
            );
          }
        });
        break;
      case 'select':
        item.addEventListener('change', function (e) {
          let option = this.querySelectorAll(`[value="${item.value}"]`)[0];
          sendAnalyticsEvent(
            'event_data',
            item.dataset.eventcategory,
            item.dataset.eventaction,
            option.text
          );
        });
        break;
      case 'a':
        item.addEventListener('click', function (e) {
          e.preventDefault();
          sendAnalyticsEvent(
            'event_data',
            item.dataset.eventcategory,
            item.dataset.eventaction,
            item.dataset.eventlabel
          );
          if (item.getAttribute('target') == '_blank') {
            window.open(item.getAttribute('href'), '_blank');
          } else {
            window.location.href = item.getAttribute('href');
          }
        });
        break;
      default:
        item.addEventListener('click', function (e) {
          sendAnalyticsEvent(
            'event_data',
            item.dataset.eventcategory,
            item.dataset.eventaction,
            item.dataset.eventlabel
          );
        });
        break;
    }
  });
};

export default () => {
  setTimeout(() => {
    turnAnalyticsListenersOn();
  }, 100);
};

window.turnAnalyticsListenersOn = turnAnalyticsListenersOn;
window.sendAnalyticsEvent = sendAnalyticsEvent;
